import React from 'react';

import { useIntl } from 'react-intl-next';

import { useBootstrap } from '../../index';
import { allFilters } from '../filters';
import { SearchStoreContainer } from '../index';
export const SearchStoreProvider = ({ children }: { children: React.ReactNode }) => {
	const intl = useIntl();

	const [
		{
			queryParams,
			cloudId,
			aggAbsoluteUrl,
			initialSpaceARIs,
			user,
			products,
			allFilterExcludedProducts,
		},
		{ setQueryParams },
	] = useBootstrap();

	const config = {
		intl: intl,
		ari: '',
		cloudId: cloudId,
		userId: user?.id || '',
		initialSpaceARIs: initialSpaceARIs,
		aggAbsoluteUrl: aggAbsoluteUrl,
	};

	const { lastModified_lt, lastModified_gt, ...queryParamsInUse } = queryParams;

	return (
		<SearchStoreContainer
			queryParams={queryParamsInUse}
			allFilters={allFilters}
			config={config}
			setQueryParams={setQueryParams}
			availableProducts={products}
			allFilterExcludedProducts={allFilterExcludedProducts}
		>
			{children}
		</SearchStoreContainer>
	);
};
